import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UiComponentsService } from '@ui-components/ui-components.service';
import { Observable, Subscription, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'ingsv-adm-dropdown-search',
  templateUrl: './dropdown-search.component.html',
  styleUrls: ['./dropdown-search.component.scss']
})

export class DropdownSearchComponent implements OnInit, OnDestroy {
  @Input() inputLabel = '';
  @Input() selectedValue = '';
  @Input() options: string[];
  @Output() selectionChange = new EventEmitter<any>();

  updateDropdownSearchComponentListSub: Subscription;

  inputValue = '';
  filteredOptions$: Observable<string[]>;

  constructor(
    private uiComponentsService: UiComponentsService
  ) { }

  ngOnInit() {
    this.filteredOptions$ = of(this.options);
    this.inputValue = this.selectedValue;

    this.updateDropdownSearchComponentListSub = this.uiComponentsService.updateDropdownSearchComponentList$.subscribe(res => {
      this.filteredOptions$ = of(this.options);
      this.clearSelectedValue();
    });
  }

  ngOnDestroy() {
    if (this.updateDropdownSearchComponentListSub) {
      this.updateDropdownSearchComponentListSub.unsubscribe();
    }
  }

  getFilteredOptions(value: string, disable = false): Observable<string[]> {
    if (disable) {
      return of([]);
    }
    return of(value).pipe(
      map(filterString => this.filter(filterString)),
    );
  }

  onChange($event): void {
    this.filteredOptions$ = this.getFilteredOptions($event);
    this.inputValue = $event;
  }

  onSelectionChange($event): void {
    this.filteredOptions$ = this.getFilteredOptions('', true);
    this.inputValue = $event;
    this.selectionChange.emit($event);
  }

  updateSelection(): void {
    this.inputValue = this.selectedValue;
  }

  private clearSelectedValue(): void {
    this.inputValue = '';
    this.selectionChange.emit('');
  }

  private filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(optionValue => optionValue.toLowerCase().includes(filterValue));
  }
}
